import { NgModule } from "@angular/core";
import { PageLayoutUserComponent } from "./user/user.component";
import { PageLayoutaddUserComponent } from "./add-edit-user/adduser.component";
import { PageLayoutUserRightsSummaryComponent } from "./user-rights-summary/userrightssummary.component";
import { MaterialModule } from "@angular/material";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AccordionModule } from "ngx-bootstrap";
import { UserManagementRoutingModule } from "./user-management-routing.module";

@NgModule(
    {
        imports:[
            MaterialModule,
            UserManagementRoutingModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,           
        ],
        declarations:[
            PageLayoutUserComponent,
            PageLayoutaddUserComponent,
            PageLayoutUserRightsSummaryComponent
        ],
    }
)
export class UserManagementModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/user-management.module.ts